var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-gov-home"},[_c('h1',[_vm._v("Governance")]),_c('gov-proposal-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }